/**
 * ============================
 * Custom Order Dummy Data (案C: ダミーデータ先行 / 汎用オプション設計)
 * ============================
 * 本番では snippets/custom-order-data.liquid が
 * window.__customOrderData を JSON で埋め込む。
 * その場合こちらの FALLBACK_DUMMY_DATA は使われない。
 *
 * ■ 設計方針（汎用オプション）
 *   - option_types … オプションの共通レジストリ（単一ソース）。
 *     レザー/ファスナー/襟 などの選択肢は「種別ごとに一度だけ」定義し、
 *     複数アイテムから同じ実体を参照する（重複を持たない）。
 *   - product.option_groups … アイテムごとの「軸」の並び。
 *     type で共通レジストリを参照し、choices でそのアイテムで使える範囲だけを列挙。
 *     choices 省略時はその種別の全選択肢。
 *       kind    : "select"（選択させる） / "info"（表示のみ）
 *       pricing : "variant"（バリアント確定に使う） / "property"（選択だが価格非影響） / "none"
 *       required: 省略時 true。false の軸は未選択でもカート追加可（PRD O-7 / A-8 で実装）
 *   - variants … pricing:"variant" の軸の組合せごとに1件。
 *     selections でその組合せを表し、deposit_price = 前金額（合計の deposit_ratio%）。
 *
 * 価格ルール:
 *   - variant.deposit_price = バリアント価格 = 前金額（合計の deposit_ratio%）
 *   - 合計金額 = deposit_price / (deposit_ratio / 100)
 *   - choice.extra_price はカード表示用の差額ラベル（合計金額そのものは variant で確定）。
 *     0 / 未設定のときはサブラベルを出さない。
 *   - choice.meta_label は差額以外のサブラベル（例「40cm」）。extra_price より優先。
 *
 * ※ 画像は picsum.photos のプレースホルダー
 * ※ variant_id は 0（ダミー・実カート追加は不可 = Option B）
 */

/* ジャケットは襟×サイズの全組合せ。ダミーは価格フラット（襟・サイズで変わらない）。 */
function buildJacketVariants(collarIds, sizeIds, depositPrice) {
  const out = [];
  collarIds.forEach(function (collar) {
    sizeIds.forEach(function (size) {
      out.push({
        variant_id: 0,
        deposit_price: depositPrice,
        available: true,
        selections: { collar: collar, size: size }
      });
    });
  });
  return out;
}

const JACKET_COLLARS = ["collar-standard", "collar-stand", "collar-nocollar"];
const JACKET_SIZES = ["size-44", "size-46", "size-48", "size-50", "size-52", "size-54", "size-56"];

const FALLBACK_DUMMY_DATA = {
  // カテゴリ（配列の並び順 = タブの表示順 / データ駆動でタブ増減）
  categories: [
    { id: "bag",    name: "バッグ" },
    { id: "goods",  name: "小物" },
    { id: "jacket", name: "ジャケット" }
  ],

  // ============================
  // オプション共通レジストリ（単一ソース）
  // ============================
  option_types: {
    leather: {
      label: "レザー",
      choices: {
        "cow-brown": {
          name: "Cow Leather / Brown",
          thumbnail: "https://picsum.photos/seed/cow/600/600",
          modal_images: ["https://picsum.photos/seed/cow-close/1200/1200"],
          description: "標準となる牛革。大判で厚みがあり、繊維組織が均一で強度・耐久性に優れています。",
          extra_price: 0
        },
        "sheep-brown": {
          name: "Sheep Leather / Brown",
          thumbnail: "https://picsum.photos/seed/sheep/600/600",
          modal_images: ["https://picsum.photos/seed/sheep-close/1200/1200"],
          description: "軽くやわらかな羊革。しっとりとした質感で手に馴染みます。",
          extra_price: 30000
        },
        "goat-brown": {
          name: "Goat Leather / Brown",
          thumbnail: "https://picsum.photos/seed/goat/600/600",
          modal_images: ["https://picsum.photos/seed/goat-close/1200/1200"],
          description: "しなやかで丈夫な山羊革。銀面の特有の凸凹があり、耐摩耗性に優れています。",
          extra_price: 30000
        }
      }
    },

    zipper: {
      label: "ファスナー",
      choices: {
        "zip-black": {
          name: "Black Zipper",
          thumbnail: "https://picsum.photos/seed/zip-black/600/600",
          modal_images: ["https://picsum.photos/seed/zip-black-close/1200/1200"],
          description: "エクセラのブラックジップ。落ち着いた佇まいで素材を選びません。",
          extra_price: 0
        },
        "zip-gold": {
          name: "Gold Zipper",
          thumbnail: "https://picsum.photos/seed/zip-gold/600/600",
          modal_images: ["https://picsum.photos/seed/zip-gold-close/1200/1200"],
          description: "エクセラのゴールドジップ。華やかなアクセントになります。",
          extra_price: 5000
        }
      }
    },

    strap: {
      label: "ストラップ",
      choices: {
        "strap-short": {
          name: "ショート",
          meta_label: "30cm",
          thumbnail: "https://picsum.photos/seed/strap-short/600/600",
          modal_images: ["https://picsum.photos/seed/strap-short-close/1200/1200"],
          description: "手首にすっきり巻ける長さ。バッグを手持ちしたいときや、コンパクトに使いたい方に。"
        },
        "strap-mid": {
          name: "ミディアム",
          meta_label: "40cm",
          thumbnail: "https://picsum.photos/seed/strap-mid/600/600",
          modal_images: ["https://picsum.photos/seed/strap-mid-close/1200/1200"],
          description: "肩に軽く掛けられる長さ。普段使いのバランスに優れた標準的なストラップ長です。"
        },
        "strap-long": {
          name: "ロング",
          meta_label: "50cm",
          thumbnail: "https://picsum.photos/seed/strap-long/600/600",
          modal_images: ["https://picsum.photos/seed/strap-long-close/1200/1200"],
          description: "斜め掛けできる長さ。両手を空けたい方や、体に沿わせて持ちたい方に適しています。"
        }
      }
    },

    // 現状はジャケットのみで使用。別ジャケットが出たら type:"collar" を参照するだけ。
    collar: {
      label: "襟",
      choices: {
        "collar-standard": {
          name: "スタンダードカラー",
          thumbnail: "https://picsum.photos/seed/collar-standard/600/600",
          modal_images: ["https://picsum.photos/seed/collar-standard-close/1200/1200"],
          description: "襟の形（ダミー）。標準的な返し襟のシルエット。"
        },
        "collar-stand": {
          name: "スタンドカラー",
          thumbnail: "https://picsum.photos/seed/collar-stand/600/600",
          modal_images: ["https://picsum.photos/seed/collar-stand-close/1200/1200"],
          description: "襟の形（ダミー）。立ち襟のすっきりとしたシルエット。"
        },
        "collar-nocollar": {
          name: "ノーカラー",
          thumbnail: "https://picsum.photos/seed/collar-nocollar/600/600",
          modal_images: ["https://picsum.photos/seed/collar-nocollar-close/1200/1200"],
          description: "襟の形（ダミー）。襟のないミニマルなシルエット。"
        }
      }
    },

    size: {
      label: "サイズ",
      choices: {
        "size-44": { name: "44" },
        "size-46": { name: "46" },
        "size-48": { name: "48" },
        "size-50": { name: "50" },
        "size-52": { name: "52" },
        "size-54": { name: "54" },
        "size-56": { name: "56" }
      }
    }
  },

  // ============================
  // 商品（各アイテムは共通レジストリを参照し、使える範囲だけ列挙）
  // ============================
  products: [
    {
      id: "folded-wallet",
      category: "goods",
      name: "Folded Wallet（デモ）",
      thumbnail: "https://picsum.photos/seed/wallet/800/800",
      modal_images: [
        "https://picsum.photos/seed/wallet-1/1200/1200",
        "https://picsum.photos/seed/wallet-2/1200/1200"
      ],
      description: "ブランドを象徴する代表的な形のお財布。容量・バランス・シルエットを重視し、日常使いから特別なシーンまで対応します。",
      price_from: 65000,
      deposit_ratio: 50,
      option_groups: [
        { type: "leather", kind: "select", pricing: "variant",  choices: ["cow-brown", "sheep-brown", "goat-brown"] },
        { type: "zipper",  kind: "select", pricing: "variant",  choices: ["zip-black", "zip-gold"] },
        { type: "strap",   kind: "select", pricing: "property", choices: ["strap-short", "strap-mid", "strap-long"] }
      ],
      variants: [
        { variant_id: 0, deposit_price: 32500, available: true, selections: { leather: "cow-brown",   zipper: "zip-black" } },
        { variant_id: 0, deposit_price: 35000, available: true, selections: { leather: "cow-brown",   zipper: "zip-gold"  } },
        { variant_id: 0, deposit_price: 47500, available: true, selections: { leather: "sheep-brown", zipper: "zip-black" } },
        { variant_id: 0, deposit_price: 50000, available: true, selections: { leather: "sheep-brown", zipper: "zip-gold"  } },
        { variant_id: 0, deposit_price: 47500, available: true, selections: { leather: "goat-brown",  zipper: "zip-black" } },
        { variant_id: 0, deposit_price: 50000, available: true, selections: { leather: "goat-brown",  zipper: "zip-gold"  } }
      ]
    },
    {
      id: "tote-bag",
      category: "bag",
      name: "Tote Bag（デモ）",
      thumbnail: "https://picsum.photos/seed/tote/800/800",
      modal_images: [
        "https://picsum.photos/seed/tote-1/1200/1200",
        "https://picsum.photos/seed/tote-2/1200/1200"
      ],
      description: "たっぷり入る定番トート。素材の表情を活かした大判のフォルムで、通勤から休日まで幅広く使えます。",
      price_from: 85000,
      deposit_ratio: 50,
      option_groups: [
        { type: "leather", kind: "select", pricing: "variant",  choices: ["cow-brown", "sheep-brown", "goat-brown"] },
        { type: "zipper",  kind: "select", pricing: "variant",  choices: ["zip-black", "zip-gold"] },
        { type: "strap",   kind: "select", pricing: "property", choices: ["strap-short", "strap-mid", "strap-long"] }
      ],
      variants: [
        { variant_id: 0, deposit_price: 42500, available: true, selections: { leather: "cow-brown",   zipper: "zip-black" } },
        { variant_id: 0, deposit_price: 45000, available: true, selections: { leather: "cow-brown",   zipper: "zip-gold"  } },
        { variant_id: 0, deposit_price: 57500, available: true, selections: { leather: "sheep-brown", zipper: "zip-black" } },
        { variant_id: 0, deposit_price: 60000, available: true, selections: { leather: "sheep-brown", zipper: "zip-gold"  } },
        { variant_id: 0, deposit_price: 57500, available: true, selections: { leather: "goat-brown",  zipper: "zip-black" } },
        { variant_id: 0, deposit_price: 60000, available: true, selections: { leather: "goat-brown",  zipper: "zip-gold"  } }
      ]
    },
    {
      id: "bj1",
      category: "jacket",
      name: "BJ1 レザージャケット（デモ）",
      thumbnail: "https://picsum.photos/seed/bj1/800/800",
      modal_images: [
        "https://picsum.photos/seed/bj1-1/1200/1200",
        "https://picsum.photos/seed/bj1-2/1200/1200"
      ],
      description: "シングルライダースをベースにしたレザージャケット（デモ）。襟の形とサイズをお選びいただけます。",
      price_from: 280000,
      deposit_ratio: 50,
      option_groups: [
        { type: "collar", kind: "select", pricing: "variant", choices: JACKET_COLLARS },
        { type: "size",   kind: "select", pricing: "variant", choices: JACKET_SIZES },
        {
          kind: "info",
          label: "仕様",
          items: [
            { label: "革の種類", value: "カウレザー / ブラック" },
            { label: "革の厚み", value: "1.4mm" },
            { label: "パターン", value: "No.3" }
          ]
        }
      ],
      // 襟×サイズの全組合せ（ダミーは価格フラット：前金140,000 / 合計280,000）
      variants: buildJacketVariants(JACKET_COLLARS, JACKET_SIZES, 140000)
    }
  ]
};

/**
 * 本番切替えフック。
 * snippets/custom-order-data.liquid が window.__customOrderData をセットしていれば
 * そちら（本番データ）を優先し、無ければダミーデータにフォールバックする。
 */
window.CustomOrderData = window.__customOrderData || FALLBACK_DUMMY_DATA;
